import { yieldToMain } from 'assets/core/js/common'
import mobileBottomPanel from 'assets/core/js/module/mobileBottomPanel'
import checkOfferTrigger from 'assets/core/js/page/product/checkOfferTrigger'
import crossSell from 'assets/core/js/page/product/crossSell'
import favorite from 'assets/core/js/page/product/favorite'
import lastSeen from 'assets/core/js/page/product/lastSeen'
import map from 'assets/core/js/page/product/map'

/**
 * Setup components that are core on the product page.
 *
 * It should be called only after the DOM content loaded.
 */
export default (): void => {
  mobileBottomPanel('.dca-mobile-bottompanel__toggle:not([data-panel-target="header-bs-mobile-bottompanel"])')
  checkOfferTrigger()

  void (async () => {
    await yieldToMain()
    map()
    favorite()
    crossSell()
    lastSeen()
  })()
}
